import { createPreparation } from '@/features/preparations/preparations.service';
import { createPreparationVisa } from '@/features/preparations/preparationVisas.service';

export async function newAdministrativeFile(projectId, bundles, entity, visaEmitters) {
    const result = await createPreparation(projectId, {
        deliveryDuration: 5,
        ...entity,
        phase: 'administrative',
    });
    if (visaEmitters && visaEmitters.length > 0) {
        await Promise.all(
            visaEmitters.map((id) =>
                createPreparationVisa(projectId, {
                    preparationId: result.id,
                    emitterId: id,
                }),
            ),
        );
    } else {
        const moe = bundles.find((bundle) => bundle.type === 'MOE');
        if (moe) {
            await createPreparationVisa(projectId, {
                preparationId: result.id,
                emitterId: moe.id,
            });
        }
        const moa = bundles.find((bundle) => bundle.type === 'MOA');
        if (moa) {
            await createPreparationVisa(projectId, {
                preparationId: result.id,
                emitterId: moa.id,
            });
        }
    }
    return result;
}
